import i18n from 'i18next';
import { registerValidator } from 'core/forms';

const isNotEmptyString = ({ fieldValue, schema, validator }) => {
  const isRequired =
    validator?.isRequired || schema.validators.some(({ type }) => type === 'isRequired');

  return {
    error: i18n.t('error-empty-string'),
    hasError: !!(fieldValue && typeof fieldValue === 'string' && !fieldValue.trim().length),
    isRequired,
  };
};

registerValidator('isNotEmptyString', isNotEmptyString);

export default isNotEmptyString;
